var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-75 border-bottom pt-1 pb-3"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('table',{class:_vm.table.class,attrs:{"id":_vm.table.id,"cellspacing":"0","width":"100%"}},[_c('thead'),_c('tbody')])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row pt-3"},[_c('h4',[_vm._v("Job List")])])
}]

export { render, staticRenderFns }